// Aggregator + lookup helper. Per-language strings live in en.js and es.js.
import en from './en';
import es from './es';

export const translations = { en, es };

export const t = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  for (const k of keys) {
    value = value?.[k];
  }
  return value || key;
};
